import React from "react";
import { Link } from "react-router-dom";
import { Check, Plus } from "lucide-react";

export const BundleTile = ({ product: p, active, picked, pickOrder, full, onToggle }) => {
  const locked = full && !picked;
  return (
    <div className={`group relative flex flex-col ${locked ? "opacity-50" : ""}`} data-testid={`bundle-tile-${p.id}`}>
      <Link
        to={`/product/${p.id}?box=${active.slug}`}
        data-testid={`bundle-product-${p.id}`}
        className={`relative block aspect-[3/4] bg-pearl rounded-xl overflow-hidden transition-[transform,box-shadow] ${
          picked ? "ring-2 ring-offset-2 ring-offset-cream" : "hover:-translate-y-1"
        }`}
        style={{ "--tw-ring-color": picked ? active.accent : "transparent" }}
      >
        <img
          src={p.image}
          alt={p.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className="absolute top-2 right-2 inline-flex items-center gap-1 px-2.5 py-1 rounded-full backdrop-blur-md"
          style={{
            background: "rgba(253,246,240,0.72)",
            boxShadow: "0 2px 6px -2px rgba(74,44,53,0.2), inset 0 0 0 1px rgba(255,255,255,0.7)",
          }}
        >
          <span className="text-[10px] font-semibold leading-none" style={{ color: active.accent === "#4A2C35" ? "#C5985A" : active.accent }}>
            {active.qty}
          </span>
          <span className="text-[9px] tracking-[0.14em] uppercase font-medium text-plum/75">for ₹{active.price}</span>
        </span>
        {picked && (
          <span
            className="absolute top-2 left-2 w-7 h-7 rounded-full flex items-center justify-center shadow text-[11px] font-bold text-white"
            style={{ background: active.accent }}
          >
            {pickOrder}
          </span>
        )}
      </Link>
      <Link to={`/product/${p.id}?box=${active.slug}`} className="mt-2 text-[13px] font-serif text-plum leading-tight line-clamp-2 min-h-[2.4em] hover:text-blush transition-colors">
        {p.name}
      </Link>
      <p className="text-[11px] text-plum/50 line-through">₹{p.mrp || p.price}</p>
      <button
        onClick={() => !locked && onToggle(p.id)}
        disabled={locked}
        data-testid={`bundle-add-to-box-${p.id}`}
        className={`mt-2 w-full inline-flex items-center justify-center gap-1.5 py-2.5 rounded-full text-[10px] sm:text-[11px] tracking-[0.22em] uppercase font-semibold transition-[background-color,color,transform] active:scale-[0.97] ${
          picked
            ? "bg-cream text-plum border border-plum/30 hover:border-plum"
            : "bg-plum text-cream hover:bg-[#5d3946] shadow-[0_8px_18px_-10px_rgba(74,44,53,0.7)]"
        } disabled:cursor-not-allowed`}
      >
        {picked ? (
          <>
            <Check size={12} strokeWidth={3} /> In Box · Remove
          </>
        ) : locked ? (
          "Box Full"
        ) : (
          <>
            <Plus size={12} strokeWidth={3} /> Add to Box
          </>
        )}
      </button>
    </div>
  );
};

export default BundleTile;
